import {
  MethodInfo,
  NextUnaryFn,
  RpcInterceptor,
  RpcOptions,
  UnaryCall,
} from '@protobuf-ts/runtime-rpc'
import { makeErrorFromRpcError } from 'shared/utils/errors/rpc.utils'
import { isK2Error } from 'shared/utils/errors/k2-error'

function normalizeError(err: unknown): never {
  throw makeErrorFromRpcError(isK2Error(err) ? err.toRpcError() : err)
}

/**
 * Interceptor that converts all RpcErrors from gRPC calls into UserError or
 * SystemError so downstream code sees a consistent error type. UserError/SystemError
 * (e.g. from BearerInterceptor) are passed through unchanged.
 *
 * Place this interceptor closest to the transport (last in the interceptors
 * array) so RpcErrors are normalized after retry logic has run.
 */
export class ErrorHandlingInterceptor implements RpcInterceptor {
  interceptUnary(
    next: NextUnaryFn,
    method: MethodInfo,
    input: object,
    options: RpcOptions,
  ): UnaryCall {
    const call = next(method, input, options)
    return new UnaryCall(
      method,
      options.meta ?? {},
      input,
      call.headers.catch(normalizeError),
      call.response.catch(normalizeError),
      call.status.catch(normalizeError),
      call.trailers.catch(normalizeError),
    )
  }
}
